'use client'

import { Building2, Code, Globe, HeartHandshake, Laptop, Users } from 'lucide-react'
import Link from 'next/link'
import { Button } from '@/components/ui/button'

export default function CareersPage() {
  const benefits = [
    {
      icon: Globe,
      title: 'Remote-First',
      description: 'Work from anywhere in the world with our distributed team.',
    },
    {
      icon: HeartHandshake,
      title: 'Health & Wellness',
      description: 'Comprehensive health coverage and wellness programs.',
    },
    {
      icon: Laptop,
      title: 'Equipment',
      description: 'Latest hardware and software to help you do your best work.',
    },
    {
      icon: Users,
      title: 'Team Events',
      description: 'Regular virtual and in-person team gatherings and events.',
    },
  ]

  const values = [
    {
      title: 'Innovation',
      description: 'We push boundaries and embrace new technologies.',
    },
    {
      title: 'Collaboration',
      description: 'We work together to achieve common goals.',
    },
    {
      title: 'Impact',
      description: 'We make a real difference in government contracting.',
    },
    {
      title: 'Growth',
      description: 'We invest in personal and professional development.',
    },
  ]

  return (
    <div className="container max-w-7xl mx-auto px-4 py-16">
      {/* Hero Section */}
      <div className="text-center mb-20">
        <h1 className="text-5xl font-bold mb-6">Join Our Team</h1>
        <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
          Join us in transforming government contracting with cutting-edge technology and making a real impact.
        </p>
      </div>

      {/* START NEW Combined Section */}
      <section className="mb-20">
        <h2 className="text-3xl font-bold text-center mb-6">Our Culture & Perks</h2>
        <p className="text-lg text-muted-foreground text-center max-w-2xl mx-auto mb-12">
          We foster an innovative and collaborative environment focused on growth, supported by benefits that help you thrive.
        </p>
        
        {/* Benefits Grid (Keep existing code) */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {benefits.map((benefit) => (
            <div key={benefit.title} className="text-center p-4 rounded-lg transition-all duration-200 hover:bg-card/50 hover:shadow-md hover:scale-105">
              <div className="inline-flex p-3 rounded-lg bg-primary/10 mb-4">
                <benefit.icon className="h-6 w-6 text-primary" />
              </div>
              <h3 className="text-xl font-semibold mb-2">{benefit.title}</h3>
              <p className="text-muted-foreground">{benefit.description}</p>
            </div>
          ))}
      </div>

        {/* Values Grid (Keep existing code, add top margin) */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mt-12 pt-12 border-t border-border/50"> 
          {values.map((value) => (
            <div key={value.title} className="text-center p-4 rounded-lg transition-all duration-200 hover:bg-card/50 hover:shadow-md hover:scale-105">
              <h3 className="text-xl font-semibold mb-2">{value.title}</h3>
              <p className="text-muted-foreground">{value.description}</p>
            </div>
          ))}
        </div>
      </section> 
      {/* END NEW Combined Section */}

      {/* Modified CTA Section */}
      <div className="text-center bg-muted/50 rounded-lg p-10">
        <h2 className="text-3xl font-bold mb-6">Interested in Future Opportunities?</h2>
        <p className="text-lg text-muted-foreground mb-8 max-w-xl mx-auto">
          No specific openings currently, but we're always keen to connect with talent passionate about govtech and AI. Reach out!
        </p>
        <Button asChild size="lg">
          <Link href="/contact">
            Connect With Us
          </Link>
        </Button>
      </div>
    </div>
  )
} 